import React, { createContext, useEffect, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Cargar sesión guardada
  useEffect(() => {
    const saved = localStorage.getItem('cap_auth');
    if (saved) {
      try { setUser(JSON.parse(saved)); } catch { /* ignore */ }
    }
  }, []);

  // Guardar sesión
  const login = (payload) => {
    // payload viene de /api/login.php => { success, username, tipo, token, expires }
    const u = {
      username: payload.username,
      tipo: payload.tipo,
      token: payload.token,
      expires: payload.expires,
    };
    setUser(u);
    localStorage.setItem('cap_auth', JSON.stringify(u));
  };

  // Cerrar sesión
  const logout = () => {
    setUser(null);
    localStorage.removeItem('cap_auth');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
